import moment from 'moment';
import { IInputState } from './date-field.types';

export const defaultInputState: IInputState = {
  day: '',
  month: '',
  year: '',
};

export function dateToInnerState(date?: Date | string | null) {
  if (date) {
    const intiDate = moment(date, undefined, true);
    if (intiDate.isValid()) {
      return {
        day: intiDate.format('DD'),
        month: intiDate.format('MM'),
        year: intiDate.format('YYYY'),
      };
    }
  }

  return { ...defaultInputState };
}

export function isDeleting(ev: React.KeyboardEvent<HTMLInputElement>) {
  return ev.key === 'Backspace' || ev.key === 'Delete';
}
